const getListingUrl = (pathname) => {
    const listingUrlItems = pathname.split('/').slice(0, -1);
    return listingUrlItems.join('/');
};
export default getListingUrl;
